import React from 'react';

export const ArrowUpLightIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.64645 11.3536C7.84171 11.5488 8.15829 11.5488 8.35355 11.3536L14.3536 5.35355C14.5488 5.15829 14.5488 4.84171 14.3536 4.64645C14.1583 4.45118 13.8417 4.45118 13.6464 4.64645L8 10.2929L2.35355 4.64645C2.15829 4.45118 1.84171 4.45118 1.64645 4.64645C1.45118 4.84171 1.45118 5.15829 1.64645 5.35355L7.64645 11.3536Z"
      fill="#2C2543"
    />
  </svg>
);
